module.exports = __webpack_public_path__ + "media/images/icons/material/landing-01f2e878f618dab6f9fa4c0f855fb354.svg";